import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2hw82wyb4: FaireProductEntity = {
  token: "p_z2hw82wyb4",
  type: "product",
  name: "Sastun®- Stone of Light- Firefly Pendant",
  brandToken: "b_4j1osx4h0b",
  brandName: "Shaman's Dawn",
  imageUrl: "https://cdn.faire.com/fastly/fd87918b5b7cadc0144dd1e0165a413f50d9161819cc7e094c0bdbe43a5ee9d7.gif",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3485725da10dc37554343642cd79ba37ab2f7f4e52a98a86b77b4eb961e0ff4e.jpeg",
    "https://cdn.faire.com/fastly/12ad44bc523e33f10082dee08b477e532f68a4e09908674407cb872012f9f04c.jpeg",
    "https://cdn.faire.com/fastly/0c2043088b5d6955281b7b6fa3bc907f767b56c9ee1214857e157206c60a63f4.jpeg",
    "https://cdn.faire.com/fastly/146507a755fb0b39ef20c7b290b10ce9ea41208c99134c35168b8ce995e226bb.jpeg",
    "https://cdn.faire.com/fastly/ba92b0065ff26a2a606018d783b7a967f886a5d08b4bb2b62a7a79d6bab507e9.jpeg",
    "https://cdn.faire.com/fastly/50828e09bb00c0806c41155b62f164ff0230cdf8066844b8672ef0293476f011.jpeg",
    "https://cdn.faire.com/fastly/01370ba061b6086a9062a3b097cb79b137f5f9eff98f0405547e3654a01abeb2.jpeg",
    "https://cdn.faire.com/fastly/2ca02fc0c9c387f2ce3dec4f407df96830d3e4c6782e6b3b152bd1423f674cf6.jpeg",
    "https://cdn.faire.com/fastly/52f424958e34daf954cf40767064ec524cb45df9afba02d91620f9938bff8e87.jpeg"
  ],
  priceDollars: 28,
  description: "Tap in to the energies of the woodlands with a Firefly Pendant set in an acorn cap.\n\nThis pendant is a handmade Sastun® set in an acorn shell with a metal bail for hanging on a cord or chain. The acorn shell has been wild-harvested and is varnished. A coating of quartz crystals on top give the pendant a druzy appearance. Each pendant is attached to an information card.\n\nThe pictures that you see are typical of the quality of our Sastun® pendants. We are not able to photograph every Firefly Pendant available. Since each Sastun® is unique, there may be variances from the photos.\n",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:14.217Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
